import { useEffect } from "react";

const useOnClickOutside = (ref, handler, notRef) => {
  useEffect(() => {
    const listener = (event) => {
      if (notRef && notRef.current && notRef.current.contains(event.target)) {
        return;
      }

      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, notRef]);
};

export default useOnClickOutside;
